/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { createContext, useState, useMemo } from 'react';
import useAuthHook from '../hooks/custom-hooks/useAuthHook';
import useAuthAPI from '../hooks/network/useAuthAPI';
import useWidgetAPI from '../hooks/network/useWidgetAPI';

const defaultWidgetSetting = {
  unSelected: [
    { name: 'MonthInvoiceDetails', customerId: '', projectId: '' },
    { name: 'RecentInvoiceDetails', customerId: '', projectId: '' },
    { name: 'ContractConsumptions', customerId: '', projectId: '' },
    { name: 'TodayDeliveredSchedule', customerId: '', projectId: '' },
    { name: 'TonnageConsumptions', customerId: '', projectId: '' },
  ],
  selected: [],
};

export const AppContext = createContext();

function AppContextProvider(props) {
  const [userProfile, setUserProfile] = useState();
  const [widgetDropDownOptions, setWidgetDropDownOptions] = useState();
  const [widgetSettings, setWidgetSettings] = useState();

  const { getUserProfile } = useAuthAPI();
  const { getDropDownOptions, getWidgets } = useWidgetAPI();
  const { isAdUser, isCustomerAdmin, userRole } = useAuthHook();

  const loadApp = () => {
    if (!isAdUser) fetchUserProfile();
    if (isAdUser || (userRole && !isCustomerAdmin)) fetchWidgetDropDownOptions();
    loadWidgetSettings();
  };

  const fetchUserProfile = async () => {
    const profile = await getUserProfile();
    setUserProfile(profile?.data);
    if (isCustomerAdmin || !userRole) {
      const options = profile?.data?.customerList?.map((c) => ({
        projects: c?.projectList?.map((p) => ({ name: p?.projectName, id: p?.projectSAPId })),
        customerID: c?.customerSAPId,
        customerName: c?.customerName,
      }));
      setWidgetDropDownOptions(options);
    }
  };

  const fetchWidgetDropDownOptions = async () => {
    const options = await getDropDownOptions();
    setWidgetDropDownOptions(options);
  };

  const loadWidgetSettings = async () => {
    try {
      const wSetting = await getWidgets();

      if (wSetting?.data?.length) {
        defaultWidgetSetting.selected = JSON.parse(wSetting?.data?.[0]?.value);
        setWidgetSettings(defaultWidgetSetting);
      } else {
        setWidgetSettings(defaultWidgetSetting);
      }
    } catch {
      setWidgetSettings(defaultWidgetSetting);
    }
  };

  const value = useMemo(
    () => ({ userProfile, widgetDropDownOptions, widgetSettings, setWidgetSettings, loadApp }),
    [widgetSettings, userProfile, widgetDropDownOptions, setWidgetSettings, loadApp],
  );

  return <AppContext.Provider value={value}>{props.children}</AppContext.Provider>;
}

export default AppContextProvider;
